export const isValidDate = (date?: string) => {
  return date ? !isNaN(Date.parse(date)) : false
}
